import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Input,
  Form,
  Alert,
} from 'reactstrap';

const ImageUploadForm = ({ onSave, updateFiles, saving }) => {
  return (
    <Container>
      <Row>
        <Col md={3} />
        <Col md={6}>
          <Form className="mb-5">
            <FormGroup>
              <Label for="files">Attach Photos</Label>
              <Input
                type="file"
                name="files"
                id="files"
                multiple={true}
                accept="image/*"
                onChange={updateFiles}
              />
            </FormGroup>

            <FormGroup>
              <Button
                color="primary"
                type="submit"
                disabled={saving}
                onClick={onSave}
                className="mr-2"
              >
                {saving ? 'Saving' : 'Save Images'}
              </Button>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

ImageUploadForm.propTypes = {
  onSave: PropTypes.func,
  updateFiles: PropTypes.func,
};

export default ImageUploadForm;



// WEBPACK FOOTER //
// ./src/components/common/ImageUploadForm.js